/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const pipelineStageInputDataSchema = z.object({
	name: z.string(),
	id: z.string().nullable().optional(),
	locked: z.boolean().nullable().optional(),
})

export type PipelineStageInputDataSchema = z.infer<typeof pipelineStageInputDataSchema>
